import { action_options, app_modules } from "helpers/apps_modules_list";
import ProductEnquiryPage from "pages/Enquiry/EnquiryProduct";
import ServiceEnquiryPage from "pages/Enquiry/EnquiryService";
import ProductEnquiryForm1 from "pages/Enquiry/Product/Form/ProductEnquiryFormV2";
import ServicesEnquiryForm2 from "pages/Enquiry/Service/Form/ServiceEnquiryFormV2";
import ProductEnquiryViewV2 from "pages/Enquiry/Product/Form/ProductEnquiryViewV2";
import ServiceEnquiryViewV2 from "pages/Enquiry/Service/Form/ServiceEnquiryViewV2";
import ProductQuotationFormV2 from "pages/QuotationV2/Form/index";
import { ServiceQuotationForm as ServiceQuotationFormV2 } from "pages/QuotationV2/Form/index";

const EnquiryRoutes: any = [
  // Create Routes
  {
    path: "/enquiry/add-product-enquiry",
    component: <ProductEnquiryForm1 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.product,
      action: action_options?.create,
    },
  },
  {
    path: "/enquiry/add-services-enquiry",
    component: <ServicesEnquiryForm2 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.service,
      action: action_options?.create,
    },
  },

  // Create quotation from enquiry
  {
    path: "/enquiry/product/create-quotation/:enquiryId",
    component: <ProductQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.product,
      action: action_options?.create,
    },
  },
  {
    path: "/enquiry/service/create-quotation/:enquiryId",
    component: <ServiceQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.service,
      action: action_options?.create,
    },
  },

  // Listing Routes
  {
    path: "/enquiry/product/:tab",
    component: <ProductEnquiryPage />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "/enquiry/service/:tab",
    component: <ServiceEnquiryPage />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.service,
      action: action_options?.view,
    },
  },

  // Edit Routes
  {
    path: "/enquiry/product/edit/:id",
    component: <ProductEnquiryForm1 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.product,
      action: action_options?.update,
    },
  },
  {
    path: "/enquiry/service/edit/:id",
    component: <ServicesEnquiryForm2 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.service,
      action: action_options?.update,
    },
  },

  // View Routes
  {
    path: "/enquiry/product/enquiry_log/view/:id",
    component: <ProductEnquiryViewV2 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "/enquiry/service/enquiry_log/view/:id",
    component: <ServiceEnquiryViewV2 />,
    permissions: {
      app_name: app_modules.enquiry.app_name,
      module_name: app_modules.enquiry.modules.service,
      action: action_options?.view,
    },
  },
];

export default EnquiryRoutes;
